import { useCallback } from 'react';
import { Box, Checkbox, Label } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function BooleanLimitEditor(_ref) {
  let {
    className,
    defaultLimit = false,
    label,
    limit = null,
    onChange,
    schema
  } = _ref;
  const handleChange = useCallback(event => {
    const newLimit = event.target.checked;
    onChange(newLimit);
  }, [onChange]);
  return /*#__PURE__*/_jsxs(Label, {
    $alignItems: "center",
    $display: "flex",
    "data-sentry-element": "Label",
    "data-sentry-component": "BooleanLimitEditor",
    "data-sentry-source-file": "BooleanLimitEditor.tsx",
    children: [/*#__PURE__*/_jsx(Box, {
      $flex: "auto",
      as: "span",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "BooleanLimitEditor.tsx",
      "data-sentry-element": "Box",
      children: label
    }), /*#__PURE__*/_jsx(Checkbox, {
      $ml: "2sp",
      checked: limit === null ? defaultLimit : limit,
      className: className,
      disabled: !schema.customizable,
      label: false,
      onChange: handleChange,
      variant: "toggle",
      "data-sentry-element": "Checkbox",
      "data-sentry-source-file": "BooleanLimitEditor.tsx",
      "data-sentry-element": "Checkbox"
    })]
  });
}